/**
 * assistantConfig.js — Rê Leve
 *
 * Nome configurável da assistente (chatbot + FAQ). Persiste em localStorage.
 * Default: "Léve" (combina com Rê Leve, sonoridade leve).
 *
 * O painel Conhecimento → Contexto permite a empresa trocar pra:
 *   - "Léve"     (default, vai bem com a marca)
 *   - "Maria"
 *   - "Helena"
 *   - "Júlia"
 *   - qualquer outro nome que decidirem.
 *
 * O nome propaga automaticamente em:
 *   - Header do chat no site cliente
 *   - Saudação inicial
 *   - Painel do operador (Conversas, Aprovações, etc.)
 *   - Apresentação acadêmica (HTML não dinâmico — manual)
 */

const LS_KEY = 'releve.assistantName';
const DEFAULT_NAME = 'Léve';

export function getAssistantName() {
  if (typeof window === 'undefined') return DEFAULT_NAME;
  try {
    return localStorage.getItem(LS_KEY) || DEFAULT_NAME;
  } catch { return DEFAULT_NAME; }
}

export function setAssistantName(name) {
  const clean = (name || '').trim() || DEFAULT_NAME;
  if (typeof window === 'undefined') return clean;
  try {
    localStorage.setItem(LS_KEY, clean);
    window.dispatchEvent(new CustomEvent('rl-assistant-name-change', { detail: clean }));
  } catch {}
  return clean;
}

/**
 * Sugestões de nomes que combinam com a marca Rê Leve.
 * Mostradas no painel Contexto para o operador escolher.
 */
export const NAME_SUGGESTIONS = [
  { name: 'Léve',   reason: 'Combina com "Rê Leve" — leveza na sonoridade' },
  { name: 'Lia',    reason: 'Curto, fácil, recifense; lembra "alegria"' },
  { name: 'Maria',  reason: 'Nome de fé brasileira, acolhedor' },
  { name: 'Helena', reason: 'Tom de cuidado e maturidade' },
  { name: 'Júlia',  reason: 'Jovem, próximo, fácil de digitar' },
  { name: 'Marina', reason: 'Combina com Recife litoral, sensação de fluidez' },
];
